import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { GuiaListMem } from "app/features/general/operativa/items/guias/listados/guias/list/listmem";

import { CambiarStatusViajeButton } from "./cambiostatus";

type Entity = models.ViajeEADDto;

export interface Props {
    value: Entity;
}

const ImprimirAcusesButton = kea.defaultProps(kea.Button, { children: "Imprimir acuses internos", iconClass: fa("print") });
const ImprimirManifiestoSalida = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto salida", iconClass: fa("list-ol") });
const ImprimirManifiestoLlegada = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto llegada", iconClass: fa("list-ol") });
const VerificarButton = kea.defaultProps(kea.Button, { children: "Consultar verificador", iconClass: fa("eye") });
/**
* Componente para editar un Entity
*/
export class ViajeEADForm extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => ({
        ...this.props,
        readonly: true
    }), undefined);

    idViajeEAD = createSelectorRx(this.value, value => value.IdRegistro);
    guias = createSelectorRx(this.idViajeEAD, id => observeResource(resources.ViajeEAD.GetGuiasEnViaje, id));

    onImprimirAcuses = async () => {
        const data = await resources.ViajeEAD.ReporteAcusesInternos(this.idViajeEAD(this.props));
        await kea.printPdf(data);
    }

    onImprimirManifiestoSalida = async () => {
        const data = await resources.ViajeEAD.ReporteManifiesto(this.idViajeEAD(this.props), true);
        await kea.printPdf(data);
    }

    onImprimirManifiestoLlegada = async () => {
        const data = await resources.ViajeEAD.ReporteManifiesto(this.idViajeEAD(this.props), false);
        await kea.printPdf(data);
    }

    onVerificar = async () => history.go("./verificar");

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Date = getField(kea.DateTime);
        const guias = this.guias(this.props);
        return (
            <div>
                <kea.Title titulo="Viaje de EAD" onRegresar={() => history.go("../")}>
                    <CambiarStatusViajeButton viaje={this.props.value} />
                    <ImprimirAcusesButton onClick={this.onImprimirAcuses} />
                    <ImprimirManifiestoSalida onClick={this.onImprimirManifiestoSalida} />
                    {
                        value.FechaFinalizoAppMovil &&
                        <ImprimirManifiestoLlegada onClick={this.onImprimirManifiestoLlegada} />
                    }
                    {this.props.value.Status == models.StatusViajeEAD.Finalizado && <VerificarButton onClick={this.onVerificar} />}
                </kea.Title>
                {kea.autogrid(3, [
                    <Text field="Folio" label="Folio" />,
                    <kea.Text label="Status" value={models.StatusViajeEAD[value.Status]} readonly />,
                    <Text field="NombreUsuario" label="Usuario capturó" />,
                    <Text field="NombreUsuarioApp" label="Usuario app móvil" />,
                    <Text field="NombreSucursal" label="Sucursal" />,
                    <Date field="FechaCreacion" label="Fecha de creacón" />,
                    <Date field="FechaInicio" label="Fecha de inicio" />,
                    <Date field="FechaFinalizoAppMovil" label="Fecha finalizó en app" />,
                    <Date field="FechaLlegadaPendienteDescarga" label="Fecha llego, pendiente descarga" />,
                    <Date field="FechaPendienteVerificacion" label="Fecha terminó descarga, pendiente de verificación" />,
                    <Date field="FechaFinalizo" label="Fecha finalizó" />,
                    <Date field="FechaCancelacion" label="Fecha de cancelación" />,
                    <Text field="NombreRuta" label="Ruta" />,
                    <Text field="NombreChofer" label="Chofer" />,
                    <Text field="NombreCamion" label="Camión" />,
                ])}

                <GuiaListMem value={guias} />
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/edit/form.tsx